import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { TextStyle } from 'data/FontStyle';
import useWindowsDimension from 'functions/useWindowsDimension';
import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import { ICompanyProductViewModel } from 'Interfaces/ICompanyProductConfig';
import React, { useEffect, useState } from 'react';
import { CompanyProductList } from '../../../pages/Companies/CompanyProductList';

type CompanyProductDrawerProps = {
  buttonIcon: React.ReactNode | null; // or 'any' if you prefer
  buttonContext: string; // or 'any', but string is typically used
  companyId: string;
  employeeId: string;
  handleChange: (
    event: React.MouseEvent<HTMLElement>,
    companyProduct: ICompanyProductViewModel
  ) => void;
};

export const CompanyProductDrawer = ({
  buttonIcon,
  buttonContext,
  companyId,
  employeeId,
  handleChange,
}: CompanyProductDrawerProps) => {
  const { width } = useWindowsDimension();
  const [open, setOpen] = useState(false);
  const [companyProducts, setCompanyProducts] = useState([]);

  let isEnabled = companyId !== 'new' && employeeId !== 'new' ? true : false;
  const { data: employeeWithProductsData } = useGet(
    rq.employeeWithProducts(companyId || '', employeeId || '', isEnabled),
    
  );

  const handleLocalChange = (
    e: React.MouseEvent<HTMLElement>,
    companyProduct: ICompanyProductViewModel
  ) => {
    // 1) Call the "external" handleChange that you received as a prop
    handleChange(e, companyProduct);

    // 2) Close the drawer
    setOpen(false);
  };

  useEffect(() => {
    if (employeeWithProductsData) {
      console.log('data', employeeWithProductsData);
      setCompanyProducts(employeeWithProductsData.companyProducts);
    }
  }, [employeeWithProductsData]);
  let buttonWidth = buttonIcon === null ? '100%' : 32;
  let buttonHeight = buttonIcon === null ? 64 : 32;
  return (
    <>
      {buttonIcon === null ? (
        <Button
          variant='contained'
          sx={{
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            width: buttonWidth || '100%',
            height: buttonHeight || '100%',
          }}
          onClick={() => setOpen(!open)}
        >
          <Typography
            sx={{
              textTransform: 'uppercase',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: 2,
              color: 'primary.text',
            }}
          >
            {buttonContext}
          </Typography>
        </Button>
      ) : (
        <Box
          sx={[
            TextStyle.buttonBox,
            {
              width: buttonWidth || 32,
              height: buttonHeight || 32,
            },
          ]}
        >
          <IconButton
            sx={{
              p: 0,
              m: 0,
              width: buttonWidth || 18,
              height: buttonHeight || 18,
            }}
            onClick={() => setOpen(!open)}
          >
            {buttonIcon}
          </IconButton>
        </Box>
      )}
      <Drawer anchor={'left'} open={open} onClose={() => setOpen(!open)}>
        <Box sx={{ width: width / 2, backgroundColor: 'primary.main' }}>
          <CompanyProductList
            companyId={companyId}
            employeeId={employeeId}
            handleChange={handleLocalChange}
            isRemoveShowCompanyView={true}
          />
        </Box>
      </Drawer>
    </>
  );
};
